import React, { useState } from "react";
import { ImageBackground, Platform, StyleSheet, View } from "react-native";
import styled from "styled-components";
import getPlatformType from "../../helpers/getPlatform";
import BackGroundGenerator from "../LandingPages/common/BackGroundGenerator";
import ODSTabs from "../../../openbrix-design-system/ui/atoms/ODSTabs";
import { useTheme } from "@emotion/react";
import { replaceAction } from "../../helpers/navigationHelpers";
import ODSButton from "../../../openbrix-design-system/ui/atoms/ODSButton";
import HomeSetupContent from "./homeSetupContent";

const layoutType = getPlatformType();

const HomeSetupScreen = (props) => {
  const { colors } = useTheme();

  return (
    <BackGroundGenerator props={props} hideMiddleLogo isLanding>
      <View style={{ flex: 1 }}>
        <ImageBackground
          source={require('../../../openbrix-design-system/images/banner/web/my-account.png')}
          style={{
            width: '100%',
            height: '346px',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
          resizeMode="cover"
        >
          <ODSButton
            rIcon={'TB-Arrow-Left'}
            restStyle={{ marginTop: 100, marginLeft: layoutType == "web" ? 60 : 20 }}
            type="secondary"
            disabled={false}
            onPress={() => replaceAction(props?.navigation, 'Dashboard')}
          >
            Back
          </ODSButton>
        </ImageBackground>
        <View style={{ padding: 16, width: layoutType == "phone" ? '100%' : '70%', alignSelf: 'center', top: -80, zIndex: 100 }}>
          <View style={styles.shadowBox}>
            <ODSTabs
              items={['HomeSetup']}
              selectedColor={colors.main.blue[700]}
              color={colors.main.blue[500]}
              activeTab={0}
              onTabChange={() => { }}
              restStyle={{ marginBottom: 16 }}
            />
            <HomeSetupContent />
          </View>
        </View>
      </View>
    </BackGroundGenerator>
  );
};

const styles = StyleSheet.create({
  shadowBox: {
    backgroundColor: '#fff',
    padding: 32,
    top: -8,
    zIndex: 1000,
    borderBottomRightRadius: 12,
    borderBottomLeftRadius: 12,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 3 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
      },
      android: {
        elevation: 4,
      },
      web: {
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 3 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
      }
    }),
  },
});

export default HomeSetupScreen;
